module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_als_r1"
    }
  }, [_vm._v("Also by David Gessner")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_tp_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_ded_r1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_epi_r1"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_fm1_r1"
    }
  }, [_vm._v("PRELUDE: INTO THE GULF")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('a', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_p01_r1"
    }
  }, [_vm._v(" In the Thick of It")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c01_r1"
    }
  }, [_vm._v("THE GREEN SUN RISES: JULY 16, 2010")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c02_r1"
    }
  }, [_vm._v("FORCES OF NATURE")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_p02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" My Crowded Day")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UP IN THE AIR")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE CASE AGAINST STRAIGHT LINES")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RUSSIAN DOLLS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BEYOND FLIPPER")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A NIGHT AT THE FISH CAMP")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_p03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" “Firm Ground Is Not Available Ground”")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BARRIERS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STRESS BALLS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE OILED PELICAN")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ATLANTIS")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_p04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Beyond the Oiled Pelican")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MIGRATIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DÉJÀ VU: A NORTHERN INTERLUDE")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_p05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Return")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWO STORIES")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FAITH")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c16_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENERGY")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_c17_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ADAPTATION")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_nts_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_ack_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_bm3_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MILKWEED EDITIONS")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/davi_9781571318398_oeb_cop_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bba4825","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/davi_9781571318398_oeb_toc_r1.vue
// module id = 63
// module chunks = 0